import { conformToMask } from 'react-text-mask';

import type { ScheduleAddress } from '@shared/types/schedules';

export const validAddress = (address: ScheduleAddress): string => {
	return (
		address &&
		(address.city ? `г. ${address.city}` : '') +
			(address.street ? `, ул. ${address.street}` : '') +
			(address.house ? `, д. ${address.house}` : '') +
			(address.apartment ? `, к. ${address.apartment}` : '')
	);
};

const mask = [
	'+',
	/[1-9]/,
	' ',
	'(',
	/\d/,
	/\d/,
	/\d/,
	')',
	' ',
	/\d/,
	/\d/,
	/\d/,
	'-',
	/\d/,
	/\d/,
	'-',
	/\d/,
	/\d/,
];

export const getPhoneNumber = (number = '') => {
	return conformToMask(number, mask).conformedValue;
};
